/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DesignLoop
 */
export interface DesignLoop {
  /**
   *
   * @type {string}
   * @memberof DesignLoop
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof DesignLoop
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof DesignLoop
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof DesignLoop
   */
  designLoopId: string | null;
  /**
   *
   * @type {DesignLoopLoopTypeEnum}
   * @memberof DesignLoop
   */
  loopType: DesignLoopLoopTypeEnum | null;
  /**
   * Format: YYYY-MM-DD, YYYY-MM, or YYYY
   * @type {Date}
   * @memberof DesignLoop
   */
  startDate: Date | null;
  /**
   * Format: YYYY-MM-DD, YYYY-MM, or YYYY
   * @type {Date}
   * @memberof DesignLoop
   */
  endDate: Date | null;
  /**
   * Point or LineString
   * @type {string}
   * @memberof DesignLoop
   */
  geometryType: string | null;
  /**
   * Geometry coordinates as string
   * @type {string}
   * @memberof DesignLoop
   */
  designLoopPos: string | null;
  /**
   *
   * @type {string}
   * @memberof DesignLoop
   */
  installation: string;
  /**
   *
   * @type {string}
   * @memberof DesignLoop
   */
  dataOwner: string;
}

/**
 * @export
 */
export const DesignLoopLoopTypeEnum = {
  Horizontaal: "horizontaal",
  Korf: "korf",
  Verticaal: "verticaal",
} as const;
export type DesignLoopLoopTypeEnum =
  (typeof DesignLoopLoopTypeEnum)[keyof typeof DesignLoopLoopTypeEnum];

/**
 * Check if a given object implements the DesignLoop interface.
 */
export function instanceOfDesignLoop(value: object): value is DesignLoop {
  if (
    (!("designLoopId" in (value as Record<string, any>)) &&
      !("design_loop_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designLoopId"] === undefined &&
      (value as Record<string, any>)["design_loop_id"] === undefined)
  )
    return false;
  if (
    (!("loopType" in (value as Record<string, any>)) &&
      !("loop_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["loopType"] === undefined &&
      (value as Record<string, any>)["loop_type"] === undefined)
  )
    return false;
  if (
    (!("startDate" in (value as Record<string, any>)) &&
      !("start_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startDate"] === undefined &&
      (value as Record<string, any>)["start_date"] === undefined)
  )
    return false;
  if (
    (!("endDate" in (value as Record<string, any>)) &&
      !("end_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endDate"] === undefined &&
      (value as Record<string, any>)["end_date"] === undefined)
  )
    return false;
  if (
    (!("geometryType" in (value as Record<string, any>)) &&
      !("geometry_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["geometryType"] === undefined &&
      (value as Record<string, any>)["geometry_type"] === undefined)
  )
    return false;
  if (
    (!("designLoopPos" in (value as Record<string, any>)) &&
      !("design_loop_pos" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designLoopPos"] === undefined &&
      (value as Record<string, any>)["design_loop_pos"] === undefined)
  )
    return false;
  if (!("installation" in value) || value["installation"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function DesignLoopFromJSON(json: any): DesignLoop {
  return DesignLoopFromJSONTyped(json, false);
}

export function DesignLoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): DesignLoop {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    designLoopId: json["design_loop_id"],
    loopType: json["loop_type"],
    startDate: json["start_date"] == null ? null : new Date(json["start_date"]),
    endDate: json["end_date"] == null ? null : new Date(json["end_date"]),
    geometryType: json["geometry_type"],
    designLoopPos: json["design_loop_pos"],
    installation: json["installation"],
    dataOwner: json["data_owner"],
  };
}

export function DesignLoopToJSON(json: any): DesignLoop {
  return DesignLoopToJSONTyped(json, false);
}

export function DesignLoopToJSONTyped(
  value?: Omit<DesignLoop, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    design_loop_id: value["designLoopId"],
    loop_type: value["loopType"],
    start_date:
      value["startDate"] == null
        ? value["startDate"]
        : value["startDate"].toISOString().substring(0, 10),
    end_date:
      value["endDate"] == null ? value["endDate"] : value["endDate"].toISOString().substring(0, 10),
    geometry_type: value["geometryType"],
    design_loop_pos: value["designLoopPos"],
    installation: value["installation"],
    data_owner: value["dataOwner"],
  };
}
